/**
 * Convert Arabic numerals (٠-٩) to Western numerals (0-9)
 * This allows users to input numbers in Arabic while storing them in Western format
 * @param {string} value - The input value that may contain Arabic numerals
 * @returns {string} - The value with Arabic numerals converted to Western numerals
 */
export const convertArabicNumerals = (value) => {
  if (!value) return value;
  
  const arabicToWestern = {
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
  };
  
  return value.replace(/[٠-٩]/g, (char) => arabicToWestern[char] || char);
};

